import {
  RECIPIENT_COPY_TAG_TOOLTIP,
  RECIPIENT_COPY_TAG_TOOLTIP_DETAIL,
} from './DocumentRecipientCopyTag.constants';

export const getRecipientCopyTagTooltip = signerName =>
  signerName ? `${signerName}'s ${RECIPIENT_COPY_TAG_TOOLTIP_DETAIL}` : RECIPIENT_COPY_TAG_TOOLTIP;
